"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchlistService = void 0;
const firebaseBase_1 = require("./firebaseBase");
const movieUtils_1 = require("../utils/movieUtils");
const unifiedFirestoreService_1 = require("./unifiedFirestoreService");
const constants_1 = require("../constants");
/**
 * Watchlist Service (Cross-Platform)
 * Handles watchlist management and collaboration features
 */
class WatchlistService {
    // =============== WATCHLIST CRUD OPERATIONS ===============
    /**
     * Create a new watchlist
     */
    createWatchlist(user, name, description, isPublic = false) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const watchlistId = (0, firebaseBase_1.doc)((0, firebaseBase_1.collection)((0, firebaseBase_1.getDb)(), 'watchlists')).id;
                const watchlist = {
                    name: name,
                    description: description,
                    isPrivate: !isPublic,
                    createdBy: user.uid,
                    movieDetails: [],
                    collaborators: [],
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString(),
                };
                // Create watchlist document (platform-aware)
                yield (0, unifiedFirestoreService_1.unifiedSetDoc)('watchlists', watchlistId, watchlist);
                console.log('WatchlistService: Watchlist created successfully with ID:', watchlistId);
                return watchlistId;
            }), 'createWatchlist');
        });
    }
    /**
     * Get user's watchlists
     */
    getUserWatchlists(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('watchlists')
                    .where('createdBy', '==', userId)
                    .getDocs();
                return querySnapshot.map(doc => (Object.assign({ id: doc.id }, doc.data())));
            }), 'getUserWatchlists');
        });
    }
    /**
     * Save user watchlist
     */
    saveUserWatchlist(user, watchlistData) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                console.log('WatchlistService: Starting save for user:', user.uid);
                console.log('WatchlistService: Watchlist data:', watchlistData);
                // Build the watchlist data, only including defined values
                const watchlist = {
                    name: watchlistData.name,
                    isPrivate: watchlistData.isPrivate,
                    createdBy: user.uid,
                    movieDetails: watchlistData.movieDetails,
                    createdAt: new Date().toISOString(),
                    updatedAt: new Date().toISOString(),
                };
                // Only add optional fields if they are defined and not empty
                if (watchlistData.description && watchlistData.description.trim()) {
                    watchlist.description = watchlistData.description.trim();
                }
                if (watchlistData.collaborators && watchlistData.collaborators.length > 0) {
                    watchlist.collaborators = watchlistData.collaborators;
                }
                console.log('WatchlistService: Final watchlist object to save:', watchlist);
                // Use platform-aware addDoc
                const docId = yield (0, unifiedFirestoreService_1.unifiedAddDoc)('watchlists', watchlist);
                console.log('WatchlistService: Watchlist saved successfully with ID:', docId);
                return docId;
            }), 'saveUserWatchlist');
        });
    }
    /**
     * Update user watchlist
     */
    updateUserWatchlist(watchlistId, updates) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Filter out undefined values to prevent Firestore errors
                const cleanUpdates = {
                    updatedAt: new Date().toISOString(),
                };
                // Only include defined values
                Object.keys(updates).forEach(key => {
                    const value = updates[key];
                    if (value !== undefined) {
                        cleanUpdates[key] = value;
                    }
                });
                // Use platform-aware updateDoc
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, cleanUpdates);
                console.log('WatchlistService: Watchlist updated successfully');
            }), 'updateUserWatchlist');
        });
    }
    /**
     * Delete user watchlist
     */
    deleteUserWatchlist(watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Use platform-aware deleteDoc
                yield (0, unifiedFirestoreService_1.unifiedDeleteDoc)('watchlists', watchlistId);
                console.log('WatchlistService: Watchlist deleted successfully');
            }), 'deleteUserWatchlist');
        });
    }
    /**
     * Get public watchlists
     */
    getPublicWatchlists(limitCount = 20) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('watchlists')
                    .where('isPrivate', '==', false)
                    .getDocs();
                const watchlists = querySnapshot
                    .map((doc) => (Object.assign({ id: doc.id }, doc.data())))
                    .slice(0, limitCount);
                console.log(`✅ WatchlistService.getPublicWatchlists: Found ${watchlists.length} public watchlists`);
                return watchlists;
            }), 'getPublicWatchlists');
        });
    }
    /**
     * Get trending watchlists (sorted by follower count)
     */
    getTrendingWatchlists(limitCount = 15) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('watchlists')
                    .where('isPrivate', '==', false)
                    .getDocs();
                // Sort by followerCount (descending) and filter out watchlists with no movies
                const watchlists = querySnapshot
                    .map((doc) => (Object.assign({ id: doc.id }, doc.data())))
                    .filter((w) => w.movieDetails && w.movieDetails.length > 0)
                    .sort((a, b) => {
                    const aFollowers = a.followerCount || 0;
                    const bFollowers = b.followerCount || 0;
                    return bFollowers - aFollowers;
                })
                    .slice(0, limitCount);
                console.log(`✅ WatchlistService.getTrendingWatchlists: Found ${watchlists.length} trending watchlists`);
                return watchlists;
            }), 'getTrendingWatchlists');
        });
    }
    // =============== MOVIE MANAGEMENT IN WATCHLISTS ===============
    /**
     * Add movie to a specific watchlist - enhanced with duplicate prevention
     */
    addMovieToWatchlist(watchlistId, movieId, movieDetails) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (!movieId) {
                    throw new Error('Movie ID is required');
                }
                console.log('WatchlistService.addMovieToWatchlist: Adding movie ID:', movieId);
                console.log('WatchlistService.addMovieToWatchlist: Movie details:', movieDetails);
                // Get current watchlist data to check for duplicates (platform-aware)
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (!watchlistDoc.exists()) {
                    throw new Error('Watchlist not found');
                }
                const watchlistData = watchlistDoc.data();
                const currentMovies = watchlistData.movieDetails || [];
                console.log('WatchlistService.addMovieToWatchlist: Current movies in watchlist:', currentMovies.length);
                // Prefer full movie payload so TMDB numeric id wins over imdb `tt*` (aligns with movieCache keys)
                const mergeForStandard = movieDetails && typeof movieDetails === 'object'
                    ? Object.assign(Object.assign({}, movieDetails), { id: (_a = movieDetails.id) !== null && _a !== void 0 ? _a : movieId }) : { id: movieId };
                const standardizedNewId = (0, movieUtils_1.getStandardizedMovieId)(mergeForStandard);
                console.log('WatchlistService.addMovieToWatchlist: Standardized new ID:', standardizedNewId);
                const existingMovieIndex = currentMovies.findIndex((movie) => {
                    const standardizedExistingId = (0, movieUtils_1.getStandardizedMovieId)(movie);
                    console.log(`WatchlistService.addMovieToWatchlist: Checking existing movie "${movie.Title || movie.title}" ID: ${movie.id} -> Standardized: ${standardizedExistingId}`);
                    return standardizedExistingId === standardizedNewId;
                });
                if (existingMovieIndex !== -1) {
                    console.log('WatchlistService.addMovieToWatchlist: Movie already exists in watchlist (duplicate prevention)');
                    return; // Don't add duplicate
                }
                if (currentMovies.length >= constants_1.APP_CONFIG.MAX_CUSTOM_WATCHLIST_SIZE) {
                    throw new Error(`This watchlist has reached the ${constants_1.APP_CONFIG.MAX_CUSTOM_WATCHLIST_SIZE}-movie limit. Remove some movies to add new ones.`);
                }
                // Add the new movie
                const movieToAdd = movieDetails || { id: movieId, addedAt: new Date().toISOString() };
                if (!movieToAdd.addedAt) {
                    movieToAdd.addedAt = new Date().toISOString();
                }
                // Ensure the movie has the standardized ID
                movieToAdd.id = standardizedNewId;
                console.log('WatchlistService.addMovieToWatchlist: Movie to add:', movieToAdd);
                // Instead of using arrayUnion, update the array manually to ensure consistency
                const updatedMovies = [...currentMovies, movieToAdd];
                // Use platform-aware updateDoc
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, {
                    movieDetails: updatedMovies,
                    updatedAt: new Date().toISOString(),
                });
                console.log('WatchlistService.addMovieToWatchlist: Movie added successfully. New count:', updatedMovies.length);
            }), 'addMovieToWatchlist');
        });
    }
    /**
     * Remove movie from a specific watchlist
     */
    removeMovieFromWatchlist(watchlistId, movieId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Get current watchlist data (platform-aware)
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (!watchlistDoc.exists()) {
                    throw new Error('Watchlist not found');
                }
                const watchlistData = watchlistDoc.data();
                const currentMovies = watchlistData.movieDetails || [];
                // Find and remove the movie using standardized ID matching
                const standardizedTargetId = (0, movieUtils_1.getStandardizedMovieId)({ id: movieId });
                const updatedMovies = currentMovies.filter(movie => {
                    const standardizedMovieId = (0, movieUtils_1.getStandardizedMovieId)(movie);
                    return standardizedMovieId !== standardizedTargetId;
                });
                // Use platform-aware updateDoc
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, {
                    movieDetails: updatedMovies,
                    updatedAt: new Date().toISOString(),
                });
                console.log('WatchlistService: Movie removed from watchlist successfully');
            }), 'removeMovieFromWatchlist');
        });
    }
    /**
     * Update movie note in a specific watchlist
     */
    updateMovieNote(watchlistId, movieId, note, userUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Get current watchlist data (platform-aware)
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (!watchlistDoc.exists()) {
                    throw new Error('Watchlist not found');
                }
                const watchlistData = watchlistDoc.data();
                const currentMovies = watchlistData.movieDetails || [];
                // Find and update the movie note using standardized ID matching
                const standardizedTargetId = (0, movieUtils_1.getStandardizedMovieId)({ id: movieId });
                console.log('WatchlistService.updateMovieNote: Target movie ID:', movieId);
                console.log('WatchlistService.updateMovieNote: Standardized target ID:', standardizedTargetId);
                console.log('WatchlistService.updateMovieNote: Movies in watchlist:', currentMovies.length);
                let matchCount = 0;
                const updatedMovies = currentMovies.map((movie) => {
                    const standardizedMovieId = (0, movieUtils_1.getStandardizedMovieId)(movie);
                    console.log(`WatchlistService.updateMovieNote: Movie "${movie.Title || movie.title}" ID: ${movie.id} -> Standardized: ${standardizedMovieId}`);
                    if (standardizedMovieId === standardizedTargetId) {
                        matchCount++;
                        console.log(`WatchlistService.updateMovieNote: MATCH FOUND for movie "${movie.Title || movie.title}"`);
                        const trimmedNote = note.trim();
                        if (trimmedNote === '') {
                            // Remove the note property completely when empty
                            const { note: _ } = movie, movieWithoutNote = __rest(movie, ["note"]);
                            return userUid ? Object.assign(Object.assign({}, movieWithoutNote), { lastModifiedBy: userUid }) : movieWithoutNote;
                        }
                        else {
                            // Set the note when not empty
                            return Object.assign(Object.assign({}, movie), { note: trimmedNote, lastModifiedBy: userUid });
                        }
                    }
                    return movie;
                });
                console.log(`WatchlistService.updateMovieNote: Total matches found: ${matchCount}`);
                const updateData = {
                    movieDetails: updatedMovies,
                    updatedAt: new Date().toISOString(),
                };
                // Set lastModifiedBy on the watchlist level if userUid is provided
                if (userUid) {
                    updateData.lastModifiedBy = userUid;
                }
                // Use platform-aware updateDoc
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, updateData);
                console.log('WatchlistService: Movie note updated successfully');
            }), 'updateMovieNote');
        });
    }
    /**
     * Clean up duplicate movies in a watchlist
     */
    cleanupWatchlistDuplicates(watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Get current watchlist data (platform-aware)
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (!watchlistDoc.exists()) {
                    throw new Error('Watchlist not found');
                }
                const watchlistData = watchlistDoc.data();
                const originalMovies = watchlistData.movieDetails || [];
                const originalCount = originalMovies.length;
                const { cleanedMovies, duplicatesRemoved, duplicateInfo } = this.deduplicateMovieArray(originalMovies);
                if (duplicatesRemoved > 0) {
                    // Use platform-aware updateDoc
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, {
                        movieDetails: cleanedMovies,
                        updatedAt: new Date().toISOString(),
                    });
                }
                return {
                    originalCount,
                    cleanedCount: cleanedMovies.length,
                    duplicatesRemoved,
                    duplicateInfo
                };
            }), 'cleanupWatchlistDuplicates');
        });
    }
    /**
     * Remove duplicates from a movie array
     */
    deduplicateMovieArray(movieDetails) {
        const seen = new Set();
        const cleanedMovies = [];
        let duplicatesRemoved = 0;
        const duplicateInfo = [];
        for (const movie of movieDetails) {
            const standardizedId = (0, movieUtils_1.getStandardizedMovieId)(movie);
            if (seen.has(standardizedId)) {
                duplicatesRemoved++;
                duplicateInfo.push({
                    originalId: movie.id || 'unknown',
                    standardizedId,
                    action: 'removed_duplicate'
                });
            }
            else {
                seen.add(standardizedId);
                cleanedMovies.push(movie);
                duplicateInfo.push({
                    originalId: movie.id || 'unknown',
                    standardizedId,
                    action: 'kept_original'
                });
            }
        }
        return { cleanedMovies, duplicatesRemoved, duplicateInfo };
    }
    // =============== COLLABORATION FEATURES ===============
    /**
     * Add collaborator to watchlist
     */
    addCollaboratorToWatchlist(watchlistId, collaboratorUid, inviterUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Get current watchlist data (platform-aware)
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (!watchlistDoc.exists()) {
                    throw new Error('Watchlist not found');
                }
                const watchlistData = watchlistDoc.data();
                // Check if user can add collaborators (owner or existing collaborator)
                const canEdit = watchlistData.createdBy === inviterUid ||
                    (watchlistData.collaborators && watchlistData.collaborators.includes(inviterUid));
                if (!canEdit) {
                    throw new Error('You do not have permission to add collaborators to this watchlist');
                }
                // Add collaborator if not already added
                const currentCollaborators = watchlistData.collaborators || [];
                if (!currentCollaborators.includes(collaboratorUid)) {
                    // Use manual array update for platform compatibility
                    const updatedCollaborators = [...currentCollaborators, collaboratorUid];
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, {
                        collaborators: updatedCollaborators,
                        updatedAt: new Date().toISOString(),
                    });
                }
                console.log('WatchlistService: Collaborator added successfully');
            }), 'addCollaboratorToWatchlist');
        });
    }
    /**
     * Remove collaborator from watchlist
     */
    removeCollaboratorFromWatchlist(watchlistId, collaboratorUid, removerUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Get current watchlist data (platform-aware)
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (!watchlistDoc.exists()) {
                    throw new Error('Watchlist not found');
                }
                const watchlistData = watchlistDoc.data();
                // Check if user can remove collaborators (owner or the collaborator themselves)
                const canRemove = watchlistData.createdBy === removerUid || collaboratorUid === removerUid;
                if (!canRemove) {
                    throw new Error('You do not have permission to remove this collaborator');
                }
                // Use manual array update for platform compatibility
                const currentCollaborators = watchlistData.collaborators || [];
                const updatedCollaborators = currentCollaborators.filter((uid) => uid !== collaboratorUid);
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, {
                    collaborators: updatedCollaborators,
                    updatedAt: new Date().toISOString(),
                });
                console.log('WatchlistService: Collaborator removed successfully');
            }), 'removeCollaboratorFromWatchlist');
        });
    }
    /**
     * Check if user can edit watchlist
     */
    canUserEditWatchlist(watchlistId, userUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Use platform-aware getDoc
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (!watchlistDoc.exists()) {
                    return false;
                }
                const watchlistData = watchlistDoc.data();
                // User can edit if they are the owner or a collaborator
                return watchlistData.createdBy === userUid ||
                    (!!watchlistData.collaborators && watchlistData.collaborators.includes(userUid));
            }), 'canUserEditWatchlist');
        });
    }
    /**
     * Get watchlists where user is a collaborator
     */
    getCollaborativeWatchlists(userUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('watchlists')
                    .where('collaborators', 'array-contains', userUid)
                    .getDocs();
                return querySnapshot.map((doc) => (Object.assign({ id: doc.id }, doc.data())));
            }), 'getCollaborativeWatchlists');
        });
    }
    /**
     * Get watchlist collaborators
     */
    getWatchlistCollaborators(watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (!watchlistDoc.exists()) {
                    return [];
                }
                const watchlistData = watchlistDoc.data();
                const collaboratorUids = watchlistData.collaborators || [];
                // Fetch collaborator profiles
                const collaboratorProfiles = [];
                for (const uid of collaboratorUids) {
                    try {
                        const userDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userProfiles', uid);
                        if (userDoc.exists()) {
                            collaboratorProfiles.push(userDoc.data());
                        }
                    }
                    catch (error) {
                        console.warn('Failed to fetch collaborator profile:', uid, error);
                    }
                }
                return collaboratorProfiles;
            }), 'getWatchlistCollaborators');
        });
    }
    // =============== UTILITY METHODS ===============
    /**
     * Get other user's watchlist data
     */
    getOtherUserWatchlistData(userId, watchlistId, currentUserUid) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (!watchlistDoc.exists()) {
                    return { watchlist: null, movieData: [] };
                }
                const watchlistData = watchlistDoc.data();
                // Check if current user can view this watchlist
                const canView = !watchlistData.isPrivate ||
                    watchlistData.createdBy === currentUserUid ||
                    (watchlistData.collaborators && watchlistData.collaborators.includes(currentUserUid || ''));
                if (!canView) {
                    return { watchlist: null, movieData: [] };
                }
                return {
                    watchlist: Object.assign(Object.assign({}, watchlistData), { id: watchlistId }),
                    movieData: watchlistData.movieDetails || []
                };
            }), 'getOtherUserWatchlistData');
        });
    }
    /**
     * Subscribe to user watchlists (real-time updates)
     */
    subscribeToUserWatchlists(uid, callback) {
        const q = (0, firebaseBase_1.query)((0, firebaseBase_1.collection)((0, firebaseBase_1.getDb)(), 'watchlists'), (0, firebaseBase_1.where)('createdBy', '==', uid));
        return (0, firebaseBase_1.onSnapshot)(q, (querySnapshot) => {
            const watchlists = querySnapshot.docs.map(doc => (Object.assign({ id: doc.id }, doc.data())));
            callback(watchlists);
        });
    }
    /**
     * Subscribe to collaborative watchlists (real-time updates)
     * Returns watchlists where the user is a collaborator but not the owner
     */
    subscribeToCollaborativeWatchlists(uid, callback) {
        console.log('🔗 WatchlistService: Setting up collaborative watchlists subscription for user:', uid);
        const q = (0, firebaseBase_1.query)((0, firebaseBase_1.collection)((0, firebaseBase_1.getDb)(), 'watchlists'), (0, firebaseBase_1.where)('collaborators', 'array-contains', uid));
        return (0, firebaseBase_1.onSnapshot)(q, (querySnapshot) => {
            console.log('📥 WatchlistService: Collaborative watchlists snapshot received:', {
                count: querySnapshot.docs.length,
                userId: uid,
                watchlistIds: querySnapshot.docs.map(doc => doc.id)
            });
            const watchlists = querySnapshot.docs.map(doc => {
                const data = doc.data();
                console.log('📋 WatchlistService: Collaborative watchlist:', {
                    id: doc.id,
                    name: data.name,
                    createdBy: data.createdBy,
                    collaborators: data.collaborators
                });
                return Object.assign({ id: doc.id }, data);
            });
            callback(watchlists);
        }, (error) => {
            console.error('❌ WatchlistService: Error in collaborative watchlists subscription:', error);
        });
    }
    /**
     * Get default watchlist settings
     */
    getDefaultWatchlistSettings(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                const settingsDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userPreferences', userId);
                if (settingsDoc.exists()) {
                    const data = settingsDoc.data();
                    return data.defaultWatchlistSettings || {};
                }
                return {};
            }), 'getDefaultWatchlistSettings');
        });
    }
    /**
     * Update default watchlist settings
     */
    updateDefaultWatchlistSettings(userId, watchlistType, updates) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Use platform-aware updateDoc
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userPreferences', userId, {
                    [`defaultWatchlistSettings.${watchlistType}`]: updates,
                    updatedAt: new Date().toISOString(),
                });
            }), 'updateDefaultWatchlistSettings');
        });
    }
    /**
     * Debug method to get watchlist data
     */
    debugWatchlistData(watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Use platform-aware getDoc
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (!watchlistDoc.exists()) {
                    return { exists: false };
                }
                const data = watchlistDoc.data();
                return {
                    exists: true,
                    data: Object.assign(Object.assign({}, data), { id: watchlistId }),
                    collaborators: data.collaborators,
                    owner: data.createdBy
                };
            }), 'debugWatchlistData');
        });
    }
    // =============== SOCIAL ACTIONS ===============
    /**
     * Like a watchlist
     */
    likeWatchlist(userId, watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (!userId || !watchlistId) {
                    throw new Error('User ID and Watchlist ID are required');
                }
                const likeDocId = `${userId}_${watchlistId}`;
                const existingLike = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlistLikes', likeDocId);
                if (existingLike.exists()) {
                    console.log('WatchlistService: Watchlist already liked — skipping increment');
                    return;
                }
                // Create a watchlistLike document (platform-aware)
                yield (0, unifiedFirestoreService_1.unifiedSetDoc)('watchlistLikes', likeDocId, {
                    userUid: userId,
                    watchlistId: watchlistId,
                    createdAt: new Date().toISOString(),
                });
                // Get current watchlist to increment follower count manually (for platform compatibility)
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (watchlistDoc.exists()) {
                    const watchlistData = watchlistDoc.data();
                    const currentCount = (watchlistData === null || watchlistData === void 0 ? void 0 : watchlistData.followerCount) || 0;
                    // Increment watchlist's follower count
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, {
                        followerCount: currentCount + 1,
                        updatedAt: new Date().toISOString(),
                    });
                    // Create user activity for liking watchlist
                    console.log('🎯 WatchlistService: About to create watchlist liked activity for:', { userId, watchlistId });
                    try {
                        const { dataService } = yield Promise.resolve().then(() => __importStar(require('./dataService')));
                        const { authService } = yield Promise.resolve().then(() => __importStar(require('./authService')));
                        const user = yield authService.getUserProfile(userId);
                        if (user) {
                            yield dataService.createUserActivity(user, 'watchlist_liked', {
                                listId: watchlistId,
                                listName: (watchlistData === null || watchlistData === void 0 ? void 0 : watchlistData.name) || 'Unknown Watchlist',
                                watchlistMovieCount: ((_a = watchlistData === null || watchlistData === void 0 ? void 0 : watchlistData.movieIds) === null || _a === void 0 ? void 0 : _a.length) || 0
                            });
                            console.log('✅ WatchlistService: Successfully created watchlist liked activity');
                        }
                    }
                    catch (activityError) {
                        console.error('❌ WatchlistService: Failed to create watchlist liked activity:', activityError);
                    }
                }
                console.log('WatchlistService: Watchlist liked successfully');
            }), 'likeWatchlist');
        });
    }
    /**
     * Unlike a watchlist
     */
    unlikeWatchlist(userId, watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                if (!userId || !watchlistId) {
                    throw new Error('User ID and Watchlist ID are required');
                }
                const likeDocId = `${userId}_${watchlistId}`;
                const existingLike = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlistLikes', likeDocId);
                if (!existingLike.exists()) {
                    console.log('WatchlistService: No like doc — skipping decrement');
                    return;
                }
                // Delete the watchlistLike document (platform-aware)
                yield (0, unifiedFirestoreService_1.unifiedDeleteDoc)('watchlistLikes', likeDocId);
                // Get current watchlist to decrement follower count manually (for platform compatibility)
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (watchlistDoc.exists()) {
                    const watchlistData = watchlistDoc.data();
                    const currentCount = (watchlistData === null || watchlistData === void 0 ? void 0 : watchlistData.followerCount) || 0;
                    // Decrement watchlist's follower count (don't go below 0)
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, {
                        followerCount: Math.max(0, currentCount - 1),
                        updatedAt: new Date().toISOString(),
                    });
                }
                console.log('WatchlistService: Watchlist unliked successfully');
            }), 'unlikeWatchlist');
        });
    }
    /**
     * Get watched status for a movie across multiple users (for collaborative watchlists)
     * Returns an array of user IDs who have watched the movie
     */
    getCollaboratorWatchedStatus(movieId, userIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                if (!movieId || !userIds || userIds.length === 0) {
                    return [];
                }
                console.log('WatchlistService: Getting watched status for movie:', movieId, 'users:', userIds);
                // Query userMovies collection for each user to check if they've watched this movie
                const watchedByUsers = [];
                // Process in batches if there are many users (Firestore has query limits)
                const batchSize = 10;
                for (let i = 0; i < userIds.length; i += batchSize) {
                    const batch = userIds.slice(i, i + batchSize);
                    const promises = batch.map((userId) => __awaiter(this, void 0, void 0, function* () {
                        try {
                            // Check the user's movie data for this movie (platform-aware)
                            const userMovieDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userMovies', `${userId}_${movieId}`);
                            if (userMovieDoc.exists()) {
                                const data = userMovieDoc.data();
                                if (data.isWatched === true) {
                                    return userId;
                                }
                            }
                            return null;
                        }
                        catch (error) {
                            console.warn(`WatchlistService: Error checking watched status for user ${userId}:`, error);
                            return null;
                        }
                    }));
                    const results = yield Promise.all(promises);
                    watchedByUsers.push(...results.filter((id) => id !== null));
                }
                console.log('WatchlistService: Watched by users:', watchedByUsers);
                return watchedByUsers;
            }), 'getCollaboratorWatchedStatus');
        });
    }
    /**
     * Get watched status for multiple movies across multiple users (for collaborative watchlists)
     * Returns a map of movieId -> array of user IDs who have watched that movie
     */
    getBulkCollaboratorWatchedStatus(movieIds, userIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                if (!movieIds || movieIds.length === 0 || !userIds || userIds.length === 0) {
                    return new Map();
                }
                console.log('WatchlistService: Getting bulk watched status for', movieIds.length, 'movies and', userIds.length, 'users');
                const result = new Map();
                // Initialize result map
                movieIds.forEach(movieId => result.set(movieId, []));
                // For each user, get all their watched movie data (platform-aware)
                const promises = userIds.map((userId) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        // Query this user's watched movies using unifiedCollection
                        const querySnapshot = yield (0, unifiedFirestoreService_1.unifiedCollection)('userMovies')
                            .where('uid', '==', userId)
                            .where('isWatched', '==', true)
                            .getDocs();
                        const watchedMovieIds = new Set(querySnapshot.map((doc) => doc.data().movieId));
                        return { userId, watchedMovieIds };
                    }
                    catch (error) {
                        console.warn(`WatchlistService: Error fetching watched movies for user ${userId}:`, error);
                        return { userId, watchedMovieIds: new Set() };
                    }
                }));
                const userWatchedData = yield Promise.all(promises);
                // Populate the result map
                for (const { userId, watchedMovieIds } of userWatchedData) {
                    for (const movieId of movieIds) {
                        if (watchedMovieIds.has(movieId)) {
                            const current = result.get(movieId) || [];
                            current.push(userId);
                            result.set(movieId, current);
                        }
                    }
                }
                console.log('WatchlistService: Bulk watched status computed');
                return result;
            }), 'getBulkCollaboratorWatchedStatus');
        });
    }
    /**
     * Increment watchlist view count
     */
    incrementWatchlistViewCount(watchlistId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                // Get current view count and increment manually (for platform compatibility)
                const watchlistDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('watchlists', watchlistId);
                if (watchlistDoc.exists()) {
                    const data = watchlistDoc.data();
                    const currentCount = (data === null || data === void 0 ? void 0 : data.viewCount) || 0;
                    yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('watchlists', watchlistId, {
                        viewCount: currentCount + 1
                    });
                }
            }), 'incrementWatchlistViewCount');
        });
    }
    /**
     * Lazily create the ⌚ companion Firestore watchlist and link it on the user profile.
     * Safe to call from web/mobile when opening the virtual `apple-watch` route.
     */
    ensureWatchCompanionWatchlist(user) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, firebaseBase_1.safeCollectionOperation)(() => __awaiter(this, void 0, void 0, function* () {
                var _a;
                const profileDoc = yield (0, unifiedFirestoreService_1.unifiedGetDoc)('userProfiles', user.uid);
                const existing = profileDoc.exists()
                    ? (_a = profileDoc.data()) === null || _a === void 0 ? void 0 : _a.watchCompanionWatchlistId
                    : undefined;
                if (existing && typeof existing === 'string' && existing.length > 0) {
                    return existing;
                }
                const watchlistId = (0, firebaseBase_1.doc)((0, firebaseBase_1.collection)((0, firebaseBase_1.getDb)(), 'watchlists')).id;
                const now = new Date().toISOString();
                yield (0, unifiedFirestoreService_1.unifiedSetDoc)('watchlists', watchlistId, {
                    name: constants_1.WATCH_COMPANION_WATCHLIST_NAME,
                    isPrivate: true,
                    createdBy: user.uid,
                    movieDetails: [],
                    collaborators: [],
                    createdAt: now,
                    updatedAt: now,
                    defaultListKind: 'apple_watch',
                });
                yield (0, unifiedFirestoreService_1.unifiedUpdateDoc)('userProfiles', user.uid, {
                    watchCompanionWatchlistId: watchlistId,
                    updatedAt: now,
                });
                return watchlistId;
            }), 'ensureWatchCompanionWatchlist');
        });
    }
}
// Export singleton instance
exports.watchlistService = new WatchlistService();
exports.default = exports.watchlistService;
